module.exports = "/wwwroot/img/youtube-brands.svg?ver=9a287ddb";